module.exports = __webpack_public_path__ + "iconWhite.png?ab979cf57e54758777af316eba66ee7b";